
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/headphones/[...slug]",
      function () {
        return require("private-next-pages/headphones/[...slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/headphones/[...slug]"])
      });
    }
  